import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../components/css/dark/img/loader.gif';


class GroupConfirmationPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }
    componentDidMount() {
    }

    HandleYes = () => {
        this.setState({ loading: true });
        if (this.props.popupName == "ResetGroup") {
            this.props.closeResetPopup();
            this.props.openManageGroup(this.props.SelectedGroupNumber, '', this.props.cPagin, this.props.cSearch, 'yes');
        }
        else if (this.props.popupName == "DeleteReps") {
            this.props.closeResetPopup();
            this.props.openEditGroup(this.props.dIndex, this.props.popupName, 'yes', this.props.userList, '', this.props.SelectedGroupNumber);
        }
    }
    handleBack = () => {
        if (this.props.popupName == "ResetGroup") {
            this.props.closeResetPopup();
            this.props.openManageGroup(this.props.SelectedGroupNumber, '', this.props.cPagin, this.props.cSearch);
        }
        else if (this.props.popupName == "DeleteReps") {
            this.props.closeResetPopup();
            this.props.openEditGroup(this.props.dIndex, this.props.popupName, 'no', this.props.userList, '', this.props.SelectedGroupNumber);
        }
    }

    render() {
        const { loading } = this.state;
        return (
            <div className='tool-section report confirmClose'>
                <div className='popup report-section'>
                    <div className='popup_inner confirm-opup'>

                        <h1>{this.props.HeadingText}<button onClick={this.handleBack}>X</button></h1>

                        <div className="pop-btn ungap">
                            <a href="javascript:void('0')" className="btn" onClick={this.HandleYes}>Yes</a>
                            <a href="javascript:void('0')" className="btn cancel" onClick={this.handleBack}>No</a>
                        </div>
                        {loading &&
                            <img className="loader" src={loader} alt="loader" />
                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default GroupConfirmationPopup;